// BUTTON
export const BUTTON = {
  DELETE: '削除',
  OK: 'OK',
  CANCEL: 'ｷｬﾝｾﾙ',
  PUBLISH: '発行',
  SAVE: '保存',
  EXECUTE: '実行',
  TEISEI: '訂正',
  TORIKESHI: '取消',
  ROW_DEL: '行削除',
  BACK: '戻る',
  CLEAR: 'クリア',
  APPROVAL: '承認',
  UNLOCK: '解除',
  CONFIRM: '確認',
  INVALID: '無効',
  PROCESS_LOG: '実行ログ',
};

// LOGIN SCREEN
export const LOGIN = {
  TITLE: 'ログイン',
  USER_LABEL: 'ユーザ名',
  USER_PLACEHOLDER: 'ユーザ名を入力してください。',
  PASSWORD_LABEL: 'パスワード',
  PASSWORD_PLACEHOLDER: 'パスワードを入力してください。',
  REDIRECT_TO_FORGET: '>> パスワードを忘れた場合',
};
export const FORGOT_PASSWORD = {
  TITLE: 'パスワードを忘れた場合',
  DESCRIPTION: '以下の手順でパスワードを新たに発行します。',
  GUIDE_STEP1: '１．発行ボタンをクリックすると、',
  GUIDE_STEP1_1: '登録メールアドレス宛に仮パスワードを送信します。',
  GUIDE_STEP2: '２．仮パスワードを使用してログイン後、',
  GUIDE_STEP2_1: '新しいパスワードを設定してください。',
};
export const CHANGE_PASSWORD = {
  TITLE: 'パスワード変更',
  SUB_TITLE: '以下に新しいパスワードを入力してください。',
  PASSWORD_LABEL: '新規パスワード',
  CONFIRM_PASSWORD_LABEL:
    '確認用（新規パスワードと同じものを入力してください）',
};

// HOME SCREEN
export const HOME = {
  TITLE: 'お知らせ',
  INFINITE_NO_RESULTS: 'お知らせがありませんでした。',
  INFINITE_NO_MORE: '全てのお知らせが表示されました。',
  INFINITE_ERROR: 'お知らせの取得中にエラーが発生しました。',
  IMPORTANT_WORD: '※重要※',
  HEADER_TITLE_KAINAI: '加工食品情報システム',
  HEADER_TITLE_KAIGAI: 'ホクレン受発注システム',
};

// ERROR SCREEN
export const ERROR = {
  TITLE: 'システムエラーが発生しました。',
  MESSAGE: `再度メニューから遷移してください。
    問題が解決されない場合は、お手数ですが管理者にご連絡ください。`,
};
